type CandidateReportLoad = {
  candidateLoggedIn: boolean;
  candidateIds?: readonly string[] | null;
  reportsFetched?: boolean;
};

// Shared by Auth's loading wait and Layout's id-based fetch. Layout adds a
// JWT and an in-flight check before it dispatches. Auth waits on the wider
// condition, including a session that does not have a JWT yet, because
// leaving that screen sends the candidate to login and login sends them back.
export const hasUnfetchedCandidateReports = ({
  candidateLoggedIn,
  candidateIds,
  reportsFetched,
}: CandidateReportLoad) =>
  Boolean(
    candidateLoggedIn && (candidateIds?.length ?? 0) > 0 && !reportsFetched,
  );

export const shouldFetchCandidateReportsById = ({
  candidateLoggedIn,
  candidateIds,
  reportsFetched,
  candidateJwt,
  reportsProcessing,
}: CandidateReportLoad & {
  candidateJwt?: string | null;
  reportsProcessing?: boolean;
}) =>
  hasUnfetchedCandidateReports({
    candidateLoggedIn,
    candidateIds,
    reportsFetched,
  }) &&
  Boolean(candidateJwt) &&
  !reportsProcessing;
